import { gql } from '@apollo/client';

const GET_EXTERNAL_PROPERTY = gql`
    query getExternalProperty($id: String!) {
        fetchExternalPropertyInformation(externalId: $id){
            error {
                code,
                message
            },
            data {
                externalId,
                propertyId,
                externalBrand,
                propertyName,
                address,
                country,
                state,
                city,
                zipCode,
                imageUrl
            }
        }
    }
`;

export {
    // eslint-disable-next-line import/prefer-default-export
    GET_EXTERNAL_PROPERTY
};
